import React from "react";
import { Controller } from "react-hook-form";
import FormErrorMessage from "./FormErrorMessage";
import CommentsUnderLabel from "./CommentsUnderLabel";

const getStyles = (rowPosition) => {
  let rowStyles = null;
  switch (rowPosition) {
    case false:
      rowStyles = { backgroundColor: 'transparent' };
      break;
    case true:
      rowStyles = { backgroundColor: 'hsl(0deg 0% 100% / 50%)' };
      break;
    case "first":
      rowStyles = { backgroundColor: 'hsl(0deg 0% 100% / 50%)', borderRadius: '4px 0 0 4px' };
      break;
    case "last":
      rowStyles = { backgroundColor: 'hsl(0deg 0% 100% / 50%)', borderRadius: '0 4px 4px 0' };
      break;
    default:
      break;
  }
  return rowStyles;
};

const FormTextarea = ({
  name,
  label,
  labelHelp,
  labelClassName = '',
  wrapperClassName='',
  control,
  placeholder,
  rows = 3,
  trigger,
  required = false,
  readOnly = false,
  disabled = false,
  rowPosition = false, // false, true, first, last
  commentsUnderLabel = []
}) => {
  return (
    <div className={`form-field ${wrapperClassName}`}>
      <label htmlFor={name} className={`form-label ${labelClassName}`}>
        {required && (
          <span className="form-layout-required" aria-label="required">
            *
          </span>
        )}
        {label}
        {labelHelp && <span className="font-italic ml-1">{labelHelp}</span>}
      </label>
      <CommentsUnderLabel commentsUnderLabel={commentsUnderLabel} />
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) => (
          <div
            className={`${rowPosition !== false ? 'px-2 pb-1' : ''}`}
            style={getStyles(rowPosition)}
          >
            {readOnly || disabled ? (
              <div
                className="form-control mt-1 h-auto"
                style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word', color:'#000000'}}
              >
                {field.value}
              </div>
            ) : (
              <textarea
                {...field}
                className={`form-control mt-1 ${fieldState.error ? "is-invalid" : ""
                  }  ${readOnly ? "bg-grey-disabled-light" : ""}`}
                placeholder={placeholder}
                rows={rows}
                id={name}
                data-testid={`form-textarea-${name}`}
                disabled={disabled}
                readOnly={readOnly}
                onBlur={(e) => {
                  field.onBlur();
                  if (trigger) {
                    trigger(name);
                  }
                }}
              />
            )}
            {fieldState.error && (
              <FormErrorMessage message={fieldState.error.message} />
            )}
          </div>
        )}
      />
    </div>
  );
};

export default FormTextarea;
